import React, { useEffect, useState } from 'react';
import { loadMyAcademyCourses, resolveMediaUrl } from '../../utils/Network';

export default function UserAcademyCourses({ translate }) {
    const [items, setItems] = useState(null);
    const [error, setError] = useState(false);

    const t = (key, fallback) => {
        if (typeof translate === 'function') return translate(key);
        return fallback;
    };

    useEffect(() => {
        let cancelled = false;
        setError(false);
        loadMyAcademyCourses()
            .then((courses) => {
                if (!cancelled) setItems(Array.isArray(courses) ? courses : []);
            })
            .catch(() => {
                if (!cancelled) {
                    setItems([]);
                    setError(true);
                }
            });
        return () => {
            cancelled = true;
        };
    }, []);

    if (items === null) {
        return (
            <div className="user-academy-courses user-academy-courses--loading">
                <p className="user-academy-courses__status mb-0 text-muted">
                    {t('Loading', 'Loading')}…
                </p>
            </div>
        );
    }

    if (error || items.length === 0) {
        return null;
    }

    return (
        <div className="user-academy-courses">
            <h3 className="user-academy-courses__heading text-color-primary">
                {t('Academy courses', 'Academy courses')}
            </h3>
            <ul className="user-academy-courses__list list-unstyled mb-0">
                {items.map((item, index) => {
                    const title = item.title != null ? String(item.title).trim() : '';
                    const url = item.url != null ? String(item.url) : '';
                    const image_url =
                        item.image_url != null ? resolveMediaUrl(String(item.image_url)) : '';
                    const key = `${url}-${title}-${index}`;
                    const tooltipTitle = title || url || 'Course';
                    const img = (
                        <span className="user-academy-courses__thumb-wrap">
                            <img
                                src={image_url || '/assets/images/default.png'}
                                alt={title || tooltipTitle || ''}
                                title={tooltipTitle}
                                className="user-academy-courses__thumb"
                            />
                            <span className="user-academy-courses__thumb-shade" aria-hidden="true" />
                            {title ? (
                                <span className="user-academy-courses__thumb-title">{title}</span>
                            ) : null}
                        </span>
                    );
                    return (
                        <li key={key} className="user-academy-courses__item">
                            {url ? (
                                <a
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="user-academy-courses__link"
                                    aria-label={tooltipTitle}
                                >
                                    {img}
                                </a>
                            ) : (
                                <div
                                    className="user-academy-courses__static"
                                    aria-label={tooltipTitle}
                                >
                                    {img}
                                </div>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
